$(document).ready(function () {
    if (myDataLayer.pageType == "category") {
        if ($(".category-loader.myloader").length == 0) {
            $("<div class='category-loader myloader'><div class='middle-banners-loader'></div><div class='references-loader'></div></div>").appendTo(".content-wrapper");
        }
    }

    if (myDataLayer.pageType == "productDetail") {
        if ($(".product-detail-loader.myloader").length == 0) {
            $("<div class='detail-loader myloader'><div class='references-loader'></div></div>").appendTo(".content-wrapper");
        }
    }

    if ($(".myloader").length) {
        $.get("/", function (data) {
            var response = $($.parseHTML(data));
            if($(".middle-banners-loader").length){
                $(response).find(".body-banners").appendTo(".middle-banners-loader");
            }
            if($(".references-loader").length){
                $(response).find(".myreferences").appendTo(".references-loader");
            }
        }, null, "html").done(function () {
            $("img[data-src]").each(function () {
                $(this).attr("src", $(this).attr("data-src"));
            });
            if($(".myreferences").length > 0) {
              const productSwiper = new Swiper('.myreferences-swiper', {
                  navigation: {
                    nextEl: ".myreferences .myswiper-next",
                    prevEl: ".myreferences .myswiper-prev",
                  },
                  slidesPerView: 4,
                  slidesPerGroup: 1,
                  spaceBetween: 30,
                  mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges: false,
                    sensitivity: 1,
                    thresholdDelta: 10,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      slidesPerGroup: 2,
                      spaceBetween: 20,
      
                    },
                    992: {
                      slidesPerView: 3,
                      slidesPerGroup: 3,
                      spaceBetween: 40,
                    },
                    1440: {
                      slidesPerView: 4,
                      spaceBetween: 40,
                    },
                  }
                });
          }
        });
    }
});